import {AfterContentInit, Component, OnInit} from '@angular/core';
import {SESSION_IDLE_URL_KEY} from "../../shared/constants";
import {FacadeService} from "../../shared/service-facade/facade.service";
import {AbandonedCardRules} from "./rules/abandoned-card-rules.abstract";
import {AbandonedCardRulesFactory} from "./rules/abandoned-card-rules.factory";

@Component({
  selector: 'app-abandoned-card',
  templateUrl: './abandoned-component.html',
  styleUrls: ['./abandoned-component.scss'],
  providers: [
    {
      provide: AbandonedCardRules,
      useFactory: AbandonedCardRulesFactory,
      deps: [
        FacadeService
      ]
    }
  ]
})
export class AbandonedComponent implements OnInit, AfterContentInit {
  cancelUrl : string = "";

  constructor(
    private facadeService: FacadeService,
    public abandonedCardRules: AbandonedCardRules
  ) { }

  ngOnInit(): void {
    this.cancelUrl = this.facadeService.getStorageItem(SESSION_IDLE_URL_KEY);
  }

  ngAfterContentInit() {
    this.facadeService.clearStorage();
    this.facadeService.clearAllCookies();
  }

  closeButton(): void {
    window.location.href = this.cancelUrl;
  }


}
